import { createLazyQuery } from '@/shared/api';
import { searchKeys } from '../keys';
import { searchKnowledgeSources } from './api';
import type { SearchKnowledgeSourceRequest } from './types';

/**
 * Ленивая загрузка списка источников знаний (ручной триггер) — под список, который сам решает,
 * какую порцию и с какими условиями запросить. Кэш общий с остальным поиском: повторный запрос
 * того же среза HTTP-запроса не делает.
 */
export const useLazyKnowledgeSourcesSearch = createLazyQuery(
  (request: SearchKnowledgeSourceRequest) => searchKeys.query(request),
  searchKnowledgeSources,
  { retry: false },
);
